import axios, { AxiosResponse } from 'axios'
import { MedicamentoDtoCadastro, MedicamentoView, PageResponseMedicamentoList } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const MEDICAMENTOS_URL = `${API_URL}/medicamentos`

/**
 * Busca todos os medicamentos
 * @param query string
 * @returns PageResponseMedicamentoList
 */
export const getMedicamentos = (query: string): Promise<PageResponseMedicamentoList> => {
  return axios
    .get(`${MEDICAMENTOS_URL}?${query}`)
    .then((resp: AxiosResponse<PageResponseMedicamentoList>) => resp.data)
}

/**
 * Busca um medicamento
 * @param medicamentoId Identificador do medicamento
 * @returns MedicamentoView
 */
export const getMedicamentoById = (medicamentoId: number): Promise<MedicamentoView> => {
  return axios
    .get(`${MEDICAMENTOS_URL}/${medicamentoId}`)
    .then((resp: AxiosResponse<MedicamentoView>) => resp.data)
}

/**
 * Cadastra um medicamento
 * @param medicamento MedicamentoDtoCadastro
 * @returns MedicamentoView
 */
export const createMedicamento = (
  medicamento: MedicamentoDtoCadastro
): Promise<MedicamentoView> => {
  return axios
    .post(MEDICAMENTOS_URL, medicamento)
    .then((resp: AxiosResponse<MedicamentoView>) => resp.data)
}

/**
 * Altera o cadastro de um medicamento
 * @param medicamentoId Identificador do medicamento
 * @param medicamento MedicamentoDtoCadastro
 * @returns MedicamentoView
 */
export const updateMedicamento = (
  medicamentoId: number,
  medicamento: MedicamentoDtoCadastro
): Promise<MedicamentoView> => {
  return axios
    .put(`${MEDICAMENTOS_URL}/${medicamentoId}`, medicamento)
    .then((resp: AxiosResponse<MedicamentoView>) => resp.data)
}

/**
 * Remove o cadastro de um medicamento
 * @param medicamentoId Identificador do medicamento
 * @returns void
 */
export const deleteMedicamento = (medicamentoId: number): Promise<void> => {
  return axios.delete(`${MEDICAMENTOS_URL}/${medicamentoId}`)
}

/**
 * Inativa ou reativa pelo admin: só a situação muda (PATCH), sem reenviar o cadastro
 * @param medicamentoId Identificador do medicamento
 * @param ativo true reativa, false inativa
 * @returns MedicamentoView
 */
export const alterarSituacaoMedicamento = (
  medicamentoId: number,
  ativo: boolean
): Promise<MedicamentoView> => {
  return axios
    .patch(`${MEDICAMENTOS_URL}/${medicamentoId}`, null, { params: { ativo } })
    .then((resp: AxiosResponse<MedicamentoView>) => resp.data)
}

/**
 * Importa medicamentos a partir de um arquivo CSV
 * @param arquivo Arquivo CSV
 * @param separador Caractere separador de colunas
 * @param cabecalhos Número de linhas de cabeçalho (linhas para desconsiderar)
 * @returns any
 */
export const importMedicamentosCsv = (
  arquivo: File,
  separador: string = ';',
  cabecalhos: number = 1
): Promise<any> => {
  const formData = new FormData()
  formData.append('arquivo', arquivo)

  const params = new URLSearchParams()
  params.append('separador', separador)
  params.append('cabecalhos', String(cabecalhos))

  return axios
    .post(`${MEDICAMENTOS_URL}/importacao/csv?${params.toString()}`, formData, {
      headers: { 'content-type': 'multipart/form-data' },
    })
    .then((resp: AxiosResponse<any>) => resp.data)
}
